export default "__VITE_ASSET__QX4rVOoQ__"